import React from 'react'
import { ContextMenu } from '@mtsbank/ui-kit'
import { ContextMenuConfigType } from '@shared/types'
import { LinkComponent } from '../ui/LinkComponent'
import { IconWithLabel } from '../ui/IconWithLabel'

export const mapContextMenu = (menus: ContextMenuConfigType[]) =>
  menus.map(({ label, routes, url }) => {
    if (url) {
      return <LinkComponent label={label} url={url} />
    }

    return routes ? (
      <ContextMenu component={<IconWithLabel label={label} />}>{routes}</ContextMenu>
    ) : (
      <IconWithLabel label={label} />
    )
  })
